var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-excel-xlsx',{attrs:{"columns":_vm.headers,"data":_vm.rows,"filename":_vm.name}},[(_vm.icon)?_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("mdi-download")])],1):_c('v-btn',{attrs:{"color":_vm.color,"text":_vm.text,"block":_vm.block}},[_vm._v("Download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }